export default __webpack_public_path__ + "static/media/schedule-icon.3fda8476.svg";